import React from "react";
import "../styles/LoadingSpinner.css";

const LoadingSpinner = ({ size = "medium" }) => {
  return (
    <div className="loading-container">
      <div className={`loading-spinner ${size}`}>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      <p className="loading-text">Loading</p>
    </div>
  );
};

export default LoadingSpinner;
